<template>
  <div>
    <b-card
      no-body
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entries</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              variant="primary"
              @click="addAssetSidebar = true"
            >
              + Tambah Data Assets
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <v-select
                v-model="statusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                class="invoice-filter-select"
                placeholder="Select Status"
              >
                <template #selected-option="{ label }">
                  <span class="text-truncate overflow-hidden">
                    {{ label }}
                  </span>
                </template>
              </v-select>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refInvoiceListTable"
        :items="rows"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="searchQuery"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
      >

        <!-- Column: Id -->
        <template #cell(id)="data">
          <span class="text-primary font-weight-bolder">#{{ data.value }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(foto_nota)="data">
          <b-img
            :src="require(`@/assets/images/pages/${data.value}`)"
            height="125"
            alt="Responsive image"
          />
        </template>

        <template #cell(menu)="data">

          <div class="text-nowrap">
            <b-button-group>
              <b-button
                :id="`asset-row-${data.item.id}-jual-icon`"
                size="sm"
                variant="info"
                @click="updateAsset(data.item, true, 'Jual')"
              >
                Jual
              </b-button>

              <b-button
                :id="`asset-row-${data.item.id}-tambah-icon`"
                size="sm"
                variant="primary"
                @click="updateAsset(data.item, true, 'Tambah')"
              >
                Tambah
              </b-button>
            </b-button-group>
          </div>
        </template>

        <template #cell(action)="data">

          <div class="text-nowrap">
            <b-button-group>
              <b-button
                :id="`bus-row-${data.item.id}-edit-icon`"
                size="sm"
                variant="warning"
                @click="editAsset(data.item, true)"
              >
                Edit
              </b-button>
              <b-tooltip
                title="Edit"
                class="cursor-pointer"
                :target="`bus-row-${data.item.id}-edit-icon`"
              />

              <b-button
                :id="`bus-row-${data.item.id}-jual-icon`"
                size="sm"
                variant="danger"
                @click="removeData(data.item.id)"
              >
                Hapus
              </b-button>
              <b-tooltip
                title="Hapus"
                :target="`bus-row-${data.item.id}-jual-icon`"
              />
            </b-button-group>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
          <!-- <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span> -->
          <!-- <span class="text-muted">Showing entries</span> -->
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalAssets"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <AddContent
      v-model="addAssetSidebar"
      :asset="dataEditAsset"
      @asset-sidebar-change="editAsset"
      @submit-data-asset="submitData"
    />

    <UpdateContent
      v-model="updateAssetSidebar"
      :asset="dataUpdateSukuCadang"
      :type-ambil="typeUpdateAsset"
      @asset-sidebar-change="updateAsset"
      @submit-data-asset="submitUpdateData"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BImg,
  BPagination, BTooltip, BButtonGroup,
  VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import AddContent from './Add.vue'
import UpdateContent from './Ambil.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BTooltip,
    BButtonGroup,
    BImg,

    AddContent,
    UpdateContent,
    vSelect,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'ID',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Nama Asset',
          key: 'nama_asset',
          sortable: true,
        },
        {
          label: 'Jumlah',
          key: 'jumlah',
          sortable: true,
        },
        {
          label: 'Menu',
          key: 'menu',
        },
        {
          label: 'Actions',
          key: 'action',
        },
      ],
      perPage: 5,
      totalAssets: 0,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      statusFilter: null,
      rowsData: [],
      searchTerm: '',
      statusOptions: [
        'Aktif',
        'Tidak Aktif',
      ],
      addAssetSidebar: false,
      dataEditAsset: {
        id: null,
        nama_asset: null,
        jumlah: null,
      },
      updateAssetSidebar: false,
      dataUpdateSukuCadang: {
        id: null,
        jumlah: null,
        foto_bukti: null,
      },
      typeUpdateAsset: null,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    rows() {
      if (this.statusFilter !== null) {
        const statusFilter = this.statusFilter === 'Aktif' ? 1 : 0

        return this.rowsData.filter(data => data.status === statusFilter)
      }
      return this.rowsData
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$http.get(`/asset-bis/bis/${this.$route.params.id}`).then(response => {
        this.rowsData = response.data.data
        this.totalAssets = response.data.data.length
      })
    },
    editAsset(data, value) {
      this.dataEditAsset = data
      this.addAssetSidebar = value
    },
    submitData(data) {
      if (data.id === null) {
        const formData = new FormData()
        formData.append('id_bis', this.$route.params.id)
        formData.append('nama_asset', data.nama_asset)
        formData.append('jumlah', data.jumlah)
        formData.append('status_pembayaran', data.status_pembayaran)
        formData.append('harga', data.harga)
        formData.append('foto_nota', data.foto_nota)
        this.$http.post('asset-bis', formData).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          this.getData()
        })
        this.dataEditAsset = {
          id: null,
          nama_asset: null,
          jumlah: null,
          status_pembayaran: null,
          harga: null,
          foto_nota: null,
        }
      } else {
        const dataAsset = {
          id_bis: this.$route.params.id,
          nama_asset: data.nama_asset,
          jumlah: data.jumlah,
          _method: 'PUT',
        }
        this.$http.post(`asset-bis/${data.id}`, dataAsset).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          this.getData()
        })
      }
      this.addAssetSidebar = false
    },
    updateAsset(data, value, type) {
      this.typeUpdateAsset = type
      this.dataUpdateSukuCadang = {
        id: data.id,
        jumlah: null,
        foto_bukti: null,
      }
      this.updateAssetSidebar = value
    },
    submitUpdateData(data) {
      if (data.type === 'Jual') {
        const formData = new FormData()
        formData.append('jumlah', data.jumlah)
        formData.append('harga', data.harga)
        formData.append('status_pembayaran', 1)
        formData.append('status_update', 'kurang')
        formData.append('foto_nota', data.foto_bukti)
        this.$http.post(`stok-asset-bis/${data.id}`, formData).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          this.getData()
        })
      } else {
        const formData = new FormData()
        formData.append('jumlah', data.jumlah)
        formData.append('harga', data.harga)
        formData.append('status_pembayaran', 1)
        formData.append('status_update', 'tambah')
        formData.append('foto_nota', data.foto_bukti)
        this.$http.post(`stok-asset-bis/${data.id}`, formData).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          this.getData()
        })
      }
      this.dataUpdateSukuCadang = {
        jumlah: null,
        foto_bukti: null,
      }
      this.updateAssetSidebar = false
    },
    removeData(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.delete(`/asset-bis/${id}`).then(response => {
            if (response.data.status === true) {
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })

              this.getData()
            } else {
              this.$swal({
                icon: 'danger',
                title: '-',
                text: response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            }
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
